<template>
  <BaseLayout :breadcrumb="breadcrumb" :show-popup="false">
    <CenteredTitle>{{ translation('forgot_page-title') }}</CenteredTitle>
    <ResetForm/>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout.vue'
import CenteredTitle from "@/components/CenteredTitle";
import ResetForm from '@/components/ResetForm.vue'
import codeBooksMixin from "@/mixins/codeBooksMixin";

export default {
  computed: {
    breadcrumb() {
      return [{
        title: this.translation('forgot_page-title'),
        url: '/reset',
      }];
    }
  },
  mixins: [codeBooksMixin],
  components: {
    BaseLayout,
    CenteredTitle,
    ResetForm,
  },
}
</script>
